module.exports = "/images/underline-icon.svg?cf7be202cd8620df507b41fa4dfc3006";